exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pager li.btn:active { -webkit-box-shadow: none; box-shadow: none; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/user/user.component.css
// module id = ../../../../../src/app/dashboard/user/user.component.css
// module chunks = main